import { Events } from './events.constant';
import { pushToDataLayer } from './push-data-layer.util';

export const GeneralProductAdapter = ({ event = Events.view_item, product, position = 1 }) => {
	console.log('GeneralProductAdapter', { event, product, position });
	pushToDataLayer({ ecommerce: null }, {
		event: event,
		ecommerce: {
			items: [
				{
					item_name: product.editable_name,
					item_id: `general-${product.id_pharol}`,
					item_brand: product.laboratory,
					item_category: product.master_category,
					item_category2: product.category,
					item_category3: product.sub_category,
					quantity: product.available,
					index: position,
				},
			],
		},
	});
};
